import { PhotoPage } from "apps/oneOnboarding/photos/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(PhotoPage, "PhotoPage");
